import { Media, MediaState } from 'components/media/store/slice';
import { RootState } from 'store';

export const selectMediaSlice = (state: RootState): MediaState => state.media;
export const selectMediaItemData = (
  state: RootState,
  itemUrl: string,
): Media => selectMediaSlice(state).data[itemUrl] || {};
